/**
 * ---------------------------------------------------
 *   INDICADORES DO PAINEL GERAL
 * ---------------------------------------------------
 */
export const GET_INDICATORS_PG_REQUEST =
  '@indicators/GET_INDICATORS_PG_REQUEST';
export const GET_INDICATORS_PG_SUCCESS =
  '@indicators/GET_INDICATORS_PG_SUCCESS';
export const GET_INDICATORS_PG_FAILURE =
  '@indicators/GET_INDICATORS_PG_FAILURE';

/**
 * ---------------------------------------------------
 *   INDICADORES DO PAINEL GERAL - ATIVAR
 * ---------------------------------------------------
 */
export const ACTIVE_INDICATORS_PG_REQUEST =
  '@indicators/ACTIVE_INDICATORS_PG_REQUEST';
export const ACTIVE_INDICATORS_PG_SUCCESS =
  '@indicators/ACTIVE_INDICATORS_PG_SUCCESS';
export const ACTIVE_INDICATORS_PG_FAILURE =
  '@indicators/ACTIVE_INDICATORS_PG_FAILURE';

/**
 * ---------------------------------------------------
 *   INDICADORES DO PAINEL GERAL - INATIVAR
 * ---------------------------------------------------
 */
export const INACTIVE_INDICATORS_PG_REQUEST =
  '@indicators/INACTIVE_INDICATORS_PG_REQUEST';
export const INACTIVE_INDICATORS_PG_SUCCESS =
  '@indicators/INACTIVE_INDICATORS_PG_SUCCESS';
export const INACTIVE_INDICATORS_PG_FAILURE =
  '@indicators/INACTIVE_INDICATORS_PG_FAILURE';

/**
 * ---------------------------------------------------
 *  ESTRATIFICAÇÃO - ATIVAR
 * ---------------------------------------------------
 */
export const ACTIVE_ESTRAT_REQUEST = '@indicators/ACTIVE_ESTRAT_REQUEST';
export const ACTIVE_ESTRAT_SUCCESS = '@indicators/ACTIVE_ESTRAT_SUCCESS';
export const ACTIVE_ESTRAT_FAILURE = '@indicators/ACTIVE_ESTRAT_FAILURE';

/**
 * ---------------------------------------------------
 *  ESTRATIFICAÇÃO - INATIVAR
 * ---------------------------------------------------
 */
export const INACTIVE_ESTRAT_REQUEST = '@indicators/INACTIVE_ESTRAT_REQUEST';
export const INACTIVE_ESTRAT_SUCCESS = '@indicators/INACTIVE_ESTRAT_SUCCESS';
export const INACTIVE_ESTRAT_FAILURE = '@indicators/INACTIVE_ESTRAT_FAILURE';
